module.exports = __webpack_public_path__ + "img/image_pred.c4aad531.png";